import { RemPreferences } from "../../api/model";
import Barrel from "../../model/Barrel";
import { ComponentLayer, ScreenComponentLayer, VirtualComponentLayer } from "../../model/ComponentLayer";
import InspectLayer from "../../model/InspectLayer";
import StyleguideData from "../../model/StyleguideData";
import { PLATFORM } from "../../enums";
import { findVirtualComponentLayer, getComponentLayerForVariant } from "../component";
import { exists } from "../object";
import { transformLayerRect } from "../transform";

function findComponentAndVirtualComponentLayer({
    layer,
    styleguidesData,
    barrel,
    platform,
    remPreferences
}: {
    layer: InspectLayer | null | undefined;
    styleguidesData: StyleguideData[] | null | undefined;
    barrel: Barrel | null | undefined;
    platform: PLATFORM;
    remPreferences: RemPreferences;
}): {
    componentLayer: ComponentLayer | null;
    virtualComponentLayer: VirtualComponentLayer | null;
    shownLayer?: InspectLayer | null;
} {
    if (!barrel) {
        return {
            componentLayer: null,
            virtualComponentLayer: null,
            shownLayer: null
        };
    }

    const { densityScale } = barrel;

    const componentLayerQueryResult = getComponentLayerForVariant(layer, styleguidesData!);

    let componentLayer = componentLayerQueryResult ? {
        _id: componentLayerQueryResult.component._id,
        componentBarrelId: componentLayerQueryResult.barrelId,
        name: componentLayerQueryResult.component.name,
        variantSectionName: componentLayerQueryResult.component.variantSectionName,
        rect: componentLayerQueryResult.layer.absoluteRect,
        renderRect: componentLayerQueryResult.layer.absoluteRenderRect,
        constraints: componentLayerQueryResult.layer.constraints,
        layer: componentLayerQueryResult.layer,
        transformedRect: transformLayerRect(componentLayerQueryResult.layer.absoluteRect, {
            platform,
            remPreferences,
            densityScale: densityScale!
        }),
        variant: !!componentLayerQueryResult.component.variant
    } : null;

    const virtualComponentLayerQueryResult = findVirtualComponentLayer(layer, styleguidesData);

    let virtualComponentLayer = virtualComponentLayerQueryResult ? {
        layer: virtualComponentLayerQueryResult,
        rect: virtualComponentLayerQueryResult.absoluteRect,
        renderRect: virtualComponentLayerQueryResult.absoluteRenderRect,
        constraints: virtualComponentLayerQueryResult.constraints,
        transformedRect: transformLayerRect(virtualComponentLayerQueryResult.absoluteRect, {
            platform,
            remPreferences,
            densityScale: densityScale!
        })
    } : null;

    if (componentLayer && virtualComponentLayer) {
        if (virtualComponentLayer.layer._id === layer?._id) {
            componentLayer = null;
        } else {
            virtualComponentLayer = null;
        }
    }

    return {
        componentLayer,
        virtualComponentLayer,
        shownLayer: componentLayerQueryResult?.layer || virtualComponentLayerQueryResult
    };
}

function isComponentLayer(layer: ScreenComponentLayer): layer is ComponentLayer {
    return exists((layer as ComponentLayer)._id);
}

export {
    findComponentAndVirtualComponentLayer,
    isComponentLayer
};
